module.exports = __webpack_public_path__ + "static/media/206.264fdd50.jpg";